import React from "react";
import { IconLayoutDashboard } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { UsageOverview } from "@features/Insights";

/** Platform usage of every service that reports metering, in the caller's scope. */
const DashboardPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <UsageOverview
      title={t("admin.insights.dashboard.title")}
      description={t("admin.insights.dashboard.description")}
      icon={<IconLayoutDashboard size={28} />}
    />
  );
};

export default DashboardPage;
